import { render, staticRenderFns } from "./TableMenuResequence.vue?vue&type=template&id=5bc83092&scoped=true"
import script from "./TableMenuResequence.vue?vue&type=script&lang=js"
export * from "./TableMenuResequence.vue?vue&type=script&lang=js"
import style0 from "./TableMenuResequence.vue?vue&type=style&index=0&id=5bc83092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc83092",
  null
  
)

export default component.exports